import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { toggleModalWorkspaceLeave } from '../../../redux/main/main.actions';
import { selectIsModalWorkspaceLeaveEnabled, selectModalWorkspaceLeaveData } from '../../../redux/main/main.selectors';
import { workspaceLeaveRequest } from '../../../redux/workspace/workspace.actions';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';
import './ModalWorkspaceLeave.scss';

export const ModalWorkspaceLeave = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();

    const isOpen = useSelector(selectIsModalWorkspaceLeaveEnabled);
    const modalData = useSelector(selectModalWorkspaceLeaveData);

    // const workspace = modalData?.workspace || null;
    // const title = workspace?.title || 'this workspace';

    const [workspace, setWorkspace] = useState(null);
    const [title, setTitle] = useState('');

    useEffect(() => {
        setWorkspace(modalData?.workspace || null);

        if (!modalData?.workspace?.title) return;

        if (title !== modalData?.workspace?.title) {
            setTitle(modalData?.workspace?.title || '');
        }

        return () => { };
    }, [modalData]);

    const handleCancel = () => {
        dispatch(toggleModalWorkspaceLeave(null));
        setTimeout(() => {
            setWorkspace(null);
            setTitle('');
        }, 300);
    };

    const handleLeave = () => {
        if (!workspace?.id) return;
        trackEvent('app_modal_workspace_leave_submit', {
            page: 'app',
            type: 'modals',
        });
        dispatch(workspaceLeaveRequest({
            id: workspace.id,
            onSuccess: () => history.push('/diagrams'),
        }));
        dispatch(toggleModalWorkspaceLeave(null));
        setTimeout(() => {
            setWorkspace(null);
            setTitle('');
        }, 300);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass="modal-workspace-leave"
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{t('m_workspace_leave.header')}</div>
            <div className="modal-content-body">
                <div className="description-text">
                    {t('m_workspace_leave.desc_prefix')}<span className="text-title-bold">{title}</span>. {t('m_workspace_leave.desc_suffix')}
                </div>
                <div className="buttons-wrap">
                    <button className="button-second" onClick={handleCancel}>{t('b.cancel')}</button>
                    <button onClick={handleLeave}>{t('b.leave')}</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalWorkspaceLeave;
